import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 8000);
    const hideTimer = setTimeout(() => setIsVisible(false), 18000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-313">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-314">
          <div className="bg-[#0f1d35] rounded-xl shadow-2xl border border-[#1e3a5f] p-4 pr-10 relative overflow-hidden" data-id="element-315">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-slate-300" data-id="element-316"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-white p-1" aria-label="Cerrar notificación" data-id="element-317">
              <X className="w-4 h-4" data-id="element-318" />
            </button>

            <div className="flex items-start gap-3" data-id="element-319">
              <div className="mt-0.5 shrink-0" data-id="element-320">
                <CheckCircle2 className="w-5 h-5 text-slate-300" data-id="element-321" />
              </div>
              <div data-id="element-322">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-323">
                  Compra verificada
                </p>
                <p className="text-sm text-slate-200 leading-tight" data-id="element-324">
                  <strong data-id="element-325">Julián C.</strong> de Mendoza compró
                  <br data-id="element-326" />
                  <span className="text-slate-300 font-medium" data-id="element-327">
                    MEGAPACK METEOROLOGÍA LISTO™ 🌩️🇦🇷
                  </span>
                </p>
                <p className="text-xs text-slate-500 mt-2" data-id="element-328">Hace 4 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}